export class Direccion {

  barrio: string;
  ciudId: number;
  direId: number;
  direccion: string;
  esPrincipal: string;
  estado: string;
  fechaCreacion: Date;
  fechaModificacion: Date;
  nombre: string;
  observacion: string;
  usuarioCreador: string;
  usuarioModificador: string;
  tercId_SicaTercero: number;
  tercId: number;
  nombreCliente: string;
  provId: number;
  paisId: number;

  constructor() {}

}
